import { ButtonContainer } from "../Button/buttons.style";
import ActionBtnU from "../../../screens/User/Users/components/ActionBtnU";
import { IncidentStatus } from "../../../types/fieldInstance.interface";
import { useIncidentFormContext } from "./IncidentContext";
import { stages } from "../../../utils/helpers/incidentFormTabs";
import { useIncidentData } from "../../../layouts/incidentLayout";
import { useFormikContext } from "formik";
import { handleNextClick } from "./methodsAndHandlers";
import { trackButtonClick } from "../../../utils/analytics";

interface BottomButtonGroupType {
  tabTitle: string;
  incidentStatus?: IncidentStatus;
  isCreateButtonDisabled: boolean;
  isDeletedIncident: boolean;
}

const BottomButtonGroup = ({
  tabTitle,
  incidentStatus,
  isCreateButtonDisabled,
  isDeletedIncident,
}: BottomButtonGroupType) => {
  const {
    shouldAllowInput: allowInput,
    isLastStep,
    currentStageIndex,
    navigateWithinForm,
    tabState,
    setIsSubmitting,
  } = useIncidentFormContext();

  const formik = useFormikContext();

  const {
    createIncidentLoading,
    setIncidentFormData,
    mergeIncidentTabState,
    selectedIncident,
  } = useIncidentData();

  // MARCC-776: hide Submit once the incident is signed/completed (resubmitting one created
  // duplicates). Based on the server status only — never true for a new incident (no status),
  // so this cannot affect creating/editing an incident.
  const isLocked =
    selectedIncident?.Incident_Status__c === IncidentStatus.SignatoryInProgress ||
    selectedIncident?.Incident_Status__c === IncidentStatus.Completed;

  const shouldToastRender = !tabState?.[tabTitle]?.isFormValid;

  function handleNavigation(path: string) {
    allowInput && setIncidentFormData(formik.values);
    navigateWithinForm(path);
  }
  function _handleNextClick(arg = stages[currentStageIndex + 1].path) {
    let path = arg;
    if (typeof arg !== "string") {
      path = stages[currentStageIndex + 1].path;
    }
    handleNextClick(
      shouldToastRender,
      tabTitle,
      mergeIncidentTabState,
      handleNavigation,
      path,
      setIsSubmitting
    );
  }

  function _handleToApprovalsClick() {
    _handleNextClick(stages[stages.length - 1].path);
  }

  return (
    <ButtonContainer currentPage={currentStageIndex}>
      {currentStageIndex !== 0 && (
        <ActionBtnU
          // data-testid="back-btn"
          data-testid={`back-btn-${tabTitle}`}
          marginRight
          purple_border
          onClick={() => handleNavigation(stages[currentStageIndex - 1].path)}
          disabled={isDeletedIncident}
        >
          Back{" "}
        </ActionBtnU>
      )}
      {isLastStep && allowInput && !isLocked ? (
        <>
          <ActionBtnU
            data-testid={`submit-btn-${tabTitle}`}
            type="submit"
            disabled={isCreateButtonDisabled || isDeletedIncident}
            purpleBg
            white_color
            onClick={() => {
              // Track Submit button click in Google Analytics if on Conclusion page
              if (tabTitle === "Conclusion") {
                trackButtonClick("conclusion_submit", { tab: tabTitle });
              }
            }}
          >
            {createIncidentLoading ? "Submitting..." : "Submit"}
          </ActionBtnU>
        </>

      ) : (
        <>
          {!isLastStep && (
            <ActionBtnU
              data-testid={`next-btn-${tabTitle}`}
              disabled={isDeletedIncident}
              purpleBg
              white_color
              onClick={_handleNextClick}
            >
              Next{" "}
            </ActionBtnU>
          )}
          {incidentStatus &&
            incidentStatus !== IncidentStatus.Draft &&
            isLastStep && (
              <ActionBtnU
                data-testid={`approvals-btn-${tabTitle}`}
                marginRight
                purpleBg
                white_color
                onClick={_handleToApprovalsClick}
                disabled={isDeletedIncident}
              >
                Approvals
              </ActionBtnU>
            )}
        </>
      )}
    </ButtonContainer>
  );
};

export default BottomButtonGroup;
